module.exports = __webpack_public_path__ + "img/4064007170.f8d1cc3b.jpg";